import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import MedicineMain from "./MedicineContainer/MedicineMain/MedicineMain";
import MedicineSidebar from "./MedicineContainer/MedicineSidebar/MedicineSidebar";
import { useApp } from "../../AppProvider";
import { useAuth } from "../../AuthProvider";
import "./MedicineGroups.css";
import api from "./../../axiosInstance"
import logger from "../../utils/logger";

const MedicineGroups = () => {
  const navigate = useNavigate();
  const { MediRecordId } = useParams();
  const { user } = useAuth();
  const [groupName, setGroupName] = useState("");
  const [selectedCard, setSelectedCard] = useState(null);
  const [currentMediRecordId, setCurrentMediRecordId] = useState(MediRecordId);
  const { medicationGroup, setMedicationGroup } = useApp();


  useEffect(() => {
    if (MediRecordId === undefined) {
      const firstMediRecordId = medicationGroup[0]?._id;
      if (firstMediRecordId) {
        setCurrentMediRecordId(firstMediRecordId);
        navigate(`/setting/managemedicinegroups/${firstMediRecordId}`);
      }
    }
  }, [MediRecordId, medicationGroup, navigate]);

  const handleGroupNameChange = (newGroupName) => {
    setGroupName(newGroupName);
  };

  const deleteMedicineGroupData = async (id) => {
    // const apiUrl = `${process.env.REACT_APP_BASE_URL}/medicationGroups/${id}`;
    try {
      const response = await api.delete(`/medicationGroups/${id}`)

    } catch (error) {
      logger.error("Error deleting medicine data:", error.message);
    }
  };
  const removeMedicationGroupFromDoctor = async (id) => {
    // const apiUrl = `${process.env.REACT_APP_BASE_URL}/doctors/medicationgroups/${user._id}`;
    try {
      const response = await api.delete(`/doctors/medicationgroups/${user._id}`)
      
      const data = response.data
      logger.debug("Updated medicine group to Doctor:", data);
      return data

    } catch (error) {
      logger.error("Error updating medicine data to Doctor:", error.message);
    }
  };

  const handleDeleteCard = async () => {
    if (selectedCard) {
      try {
        await removeMedicationGroupFromDoctor(currentMediRecordId)
        try {
          await deleteMedicineGroupData(currentMediRecordId)
          const updatedData = medicationGroup.filter(
            (card) => card._id !== currentMediRecordId
          );
          setMedicationGroup(updatedData);
          setSelectedCard(updatedData[0]);
          setCurrentMediRecordId(updatedData[0]._id);
          navigate(`/setting/managemedicinegroups/${updatedData[0]._id}`);
        } catch (error) {
          logger.error("Error in Deleting Group");
        }

      } catch (e) {
        logger.error("Error in Deleting Group");
      }
    }
  };

  useEffect(() => {
    setCurrentMediRecordId(MediRecordId);
  }, [MediRecordId]);

  useEffect(() => {
    const card = medicationGroup?.find(
      (card) => card._id === currentMediRecordId
    );
    setSelectedCard(card);
  }, [currentMediRecordId]);

  return (
    <div className="medication-group_container">
      <MedicineSidebar
        groupName={groupName}
        medicineData={medicationGroup}
        selectedCard={selectedCard}
        MediRecordId={currentMediRecordId}
        setMedicineData={setMedicationGroup}
      />
      <MedicineMain
        handleGroupNameChange={handleGroupNameChange}
        medicineData={medicationGroup}
        handleDeleteCard={handleDeleteCard}
        selectedCard={selectedCard}
        MediRecordId={currentMediRecordId}
        setSelectedCard={setSelectedCard}
      />
    </div>
  );
};

export default MedicineGroups;
